// 個人資料 → Discord 分頁：顯示綁定狀態 + 綁定 / 解除綁定。
// 綁定流程：POST /api/discord/link-token → 拿到對方綁定服務 URL → 導過去（OAuth）→ 對方導回 /discord/linked。
import { useEffect, useState, useContext } from "react";
import { Card, CircularProgress, Chip } from "@mui/material";
import { toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import axiosInstance from "api/axiosInstance";
import { LanguageContext } from "../../../../context/LanguageContext";
import { COLORS } from "theme/tokens";

export default function DiscordBindTab() {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const [loading, setLoading] = useState(true);
  const [linked, setLinked] = useState(false);
  const [username, setUsername] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    loadLanguageFile("DiscordBindTab", "profile/DiscordBindTab/DiscordBindTab_lang");
  }, [language, loadLanguageFile]);
  const L = (componentLanguageData.DiscordBindTab || { Main: {} }).Main || {};

  const fetchStatus = () => {
    setLoading(true);
    axiosInstance
      .get("/discord/status")
      .then((res) => {
        setLinked(!!res.data?.linked);
        setUsername(res.data?.discordUsername || "");
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    fetchStatus();
  }, []);

  const handleBind = async () => {
    setBusy(true);
    try {
      const res = await axiosInstance.post("/discord/link-token");
      const url = res.data?.redirectUrl || "";
      if (/^https?:\/\//i.test(url)) {
        window.location.href = url; // 導去對方綁定服務
      } else {
        toast.error(L.ErrNoUrl || "Discord 綁定服務尚未設定，請聯絡客服");
        setBusy(false);
      }
    } catch (e) {
      toast.error(L.ErrBind || "啟動綁定失敗，請稍後再試");
      setBusy(false);
    }
  };

  const handleUnbind = async () => {
    setBusy(true);
    try {
      await axiosInstance.post("/discord/unlink");
      toast.success(L.Unbound || "已解除綁定");
      fetchStatus();
    } catch (e) {
      toast.error(L.ErrUnbind || "解除綁定失敗");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card sx={{ p: { xs: 2.5, md: 3 }, borderRadius: 3, boxShadow: 0, border: `1px solid ${COLORS.grayLighter || "#eee"}`, maxWidth: 560 }}>
      <MDBox display="flex" alignItems="center" gap={1} mb={1}>
        <MDBox component="img" src="/images/icon/discord.png" alt="Discord" sx={{ width: 26, height: 26 }} onError={(e) => { e.target.style.display = "none"; }} />
        <MDTypography variant="h6" fontWeight="bold">
          {L.Title || "Discord 綁定"}
        </MDTypography>
      </MDBox>

      <MDTypography variant="body2" color="text" mb={2.5}>
        {L.Desc || "綁定 Discord 後，付費會員可自動取得社群 VIP 身分組。"}
      </MDTypography>

      {loading ? (
        <CircularProgress size={22} color="info" />
      ) : (
        <>
          <MDBox display="flex" alignItems="center" gap={1.5} mb={2.5} flexWrap="wrap">
            <MDTypography variant="button" fontWeight="medium" color="text">
              {L.StatusLabel || "狀態："}
            </MDTypography>
            {linked ? (
              <Chip label={`${L.StatusLinked || "已綁定"}${username ? `：${username}` : ""}`} color="success" size="small" />
            ) : (
              <Chip label={L.StatusUnlinked || "尚未綁定"} size="small" />
            )}
          </MDBox>

          {linked ? (
            <MDButton variant="outlined" color="error" disabled={busy} onClick={handleUnbind} sx={{ textTransform: "none" }}>
              {L.UnbindBtn || "解除綁定"}
            </MDButton>
          ) : (
            <MDButton variant="gradient" color="info" disabled={busy} onClick={handleBind} sx={{ textTransform: "none" }}>
              {busy ? <CircularProgress size={18} color="inherit" /> : (L.BindBtn || "綁定 Discord")}
            </MDButton>
          )}
        </>
      )}
    </Card>
  );
}
